import React from 'react'
import "../styles/modal.scss";

function Modal(props) {

    return (
        <div id="myModal" className="modal fade" role="dialog">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal">&times;</button>
                        <h2 className="modal-title d-flex">
                            <span className="mx-auto d-flex">
                                <i className="fas fa-exclamation-triangle text-warning mr-1"></i> Leaving Site
                            </span>
                        </h2>
                    </div>
                    <div className="modal-body">
                        <p>This link is attempting to take you to <a href="https://www.corpu.com/corpu-open/">corpu.com/corpu-open/</a>. Continue to new site? </p>
                    </div>
                    <div className="modal-footer">
                        <a href="https://www.corpu.com/corpu-open/" className="btn btn-primary" >Continue</a>
                        <button type="button" className="btn btn-default" data-dismiss="modal">Cancel</button>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default Modal;